module.exports = __webpack_public_path__ + "img/ico-logo.147d2a85.png";